export default __webpack_public_path__ + "static/media/p40.4747b021.jpg";